import { client } from "../../../Infrastructure/agent";

export const SettingService = {
  loadFlashSettings: () =>
    client.get("/setting/LoadNaocFlashReportInputSettings"),
  saveFlasSettings: (setting,uploadedBy) =>
    client.post("/setting/SaveNaocFlashReportInputSettings", { setting,uploadedBy }),
};

